import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextBody2Bold } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { useLayoutConfig } from '../contexts/layoutConfig';

interface Props {
  sequenceNumber: number;
}

export function MBSequenceNumberBlock({ sequenceNumber }: Props) {
  const colors = useContext(ColorThemeContext);
  const layout = useLayoutConfig();

  return (
    <View paddingLeft={layout.staticBlock.paddingLeft} paddingVertical={0.5}>
      <View
        shrinkWrap
        paddingHorizontal={1}
        paddingVertical={0.5}
        style={{
          backgroundColor: colors.backgroundInactive,
          borderRadius: grid(0.5),
          borderColor: colors.input.borderInactive,
          borderWidth: 1,
        }}
      >
        <MBTextBody2Bold color={colors.foregroundInactive}>ID: {sequenceNumber}</MBTextBody2Bold>
      </View>
    </View>
  );
}
